import { render, staticRenderFns } from "./EventResponseDetailsCard.vue?vue&type=template&id=b0600f94"
import script from "./EventResponseDetailsCard.vue?vue&type=script&lang=js"
export * from "./EventResponseDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports